import { render } from "./UpsertProductModal.vue?vue&type=template&id=38dbc198&scoped=true"
import script from "./UpsertProductModal.vue?vue&type=script&lang=js"
export * from "./UpsertProductModal.vue?vue&type=script&lang=js"

import "./UpsertProductModal.vue?vue&type=style&index=0&id=38dbc198&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-38dbc198"]])

export default __exports__